import Lottie from 'lottie-react';

import MeloLoading from '../../assets/animations/MeloLoading.json';

import classes from './Loading.module.scss';

const Loading = ({ className, globalLoading }) => {
  const loadingClasses = [classes.icon];
  if (className) {
    loadingClasses.push(className);
  }
  let container = null;
  if (globalLoading) {
    container = classes.container;
  }

  return (
    <div className={container}>{globalLoading && <Lottie className={classes.load} animationData={MeloLoading} loop={true} />}</div>
  );
};

export default Loading;
